import { AnyStore, BooleanStore, Disposers } from 'src/stores';

export const mapZoomStore = new AnyStore<number>(12);
export const mapStore = new AnyStore<AnyObject | null>(null);
export const distanceInfoOpeningModalStore = new BooleanStore();
export const distanceInfoStore = new AnyStore<AnyObject>({});
export const raceStore = new AnyStore<RacesType>();
export const disposers = new Disposers();
